import { Directive, ElementRef, Input } from '@angular/core';
import './../helper/modernizr.js';
declare var $: any;

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[svgFallback]'
})
export class SvgFallbackDirective {

  constructor(public elem: ElementRef) {

  }

  @Input() set svgFallback(logoSrc: string) {
    const isIE11 = /(MSIE|rv:11.0|Edge)/i.test(navigator.userAgent)
    if ((!Modernizr.svg || isIE11) && logoSrc && this.elem.nativeElement) {
      const imgAlt = $(this.elem.nativeElement)
        .find('title')
        .text()
      const imgPath = logoSrc.split('\.svg');
      $(this.elem.nativeElement)
        .replaceWith(`<img class="img-responsive" alt="${imgAlt}" src="${imgPath[0]}.png">`);
    }
  }

}
